<template>
  <div class="container-fluid">
    <d-body-top-bar
      v-if="mode === 'create'"
      :title="$t('views.client.index.new.default')"
    >
      <div slot="tree">
        <label class="inactive-tree">
          {{ $t('views.client.your-customers') }} /
        </label>
        <label
          class="pointer inactive-tree link-area ml-1"
          @click="$router.push({ name: 'clients_list'})"
        >
          {{ $t('views.client.all-customers') }}
        </label> /
        <label class="bg-doinsport-primary ml-1">
          {{ $t('views.client.index.new.default') }}
        </label>
      </div>
    </d-body-top-bar>
    <div
      class="container-fluid"
      :class="innerWidth ? '' : 'p-0'"
    >
      <!--    Create Mode       !-->
      <b-card v-if="mode === 'create'">
        <validation-observer
          slim
          ref="customerObserver"
          v-slot="{ invalid }"
        >
          <profile-informations
            :client="client"
            :validation="validation"
          />
          <personal-informations
            :client="client"
            :validation="validation"
          />
          <b-row class="mt-4 split-layout" v-if="innerWidth">
            <b-col :cols="getCols()">
              <groups
                :client="client"
              />
            </b-col>
            <div v-if="getCols() === '6'" class="split-layout__divider">
              <div class="split-layout__rule"></div>
              <div class="split-layout__rule"></div>
            </div>
            <b-col class="pl-0">
              <customer-details
                :validation="validation"
                :client="client"
                :container-class="$store.getters['layout/getInnerWidth'] < 1368 ? 'container-fluid mt-2' : 'mt-2'"
              />
            </b-col>
          </b-row>
          <div class="container-fluid">
            <b-row>
              <b-col
                :align="innerWidth ? 'right' : 'center'"
              >
                <d-button
                  text="general.actions.save"
                  class="d-btn-sm font-text-title btn d-btn-danger font-text-title"
                  :class="innerWidth ? '' : ' custom-customer-button mt-4 mb-3'"
                  @on:button-click="createOrUpdateCustomer"
                />
              </b-col>
            </b-row>
          </div>
        </validation-observer>
      </b-card>
      <!--  CustomUpdate Mode  !-->
      <validation-observer
        v-else
        slim
        ref="customerObserver"
        v-slot="{ invalid }"
      >
        <template v-if="client.id !== null">
          <profile-informations
            :client="client"
            :validation="validation"
          />
          <personal-informations
            :client="client"
            :validation="validation"
            :mode="mode"
          />
          <b-row class="mt-2">
            <b-col
              :align="innerWidth ? 'right' : 'center'"
            >
              <d-button
                text="general.actions.save"
                class="d-btn-sm font-text-title btn d-btn-danger font-text-title"
                :class="innerWidth ? '' : ' custom-customer-button mt-4 mb-3'"
                @on:button-click="createOrUpdateCustomer"
              />
            </b-col>
          </b-row>
        </template>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import Client from "@/classes/doinsport/Client";
import {getClubClient, postClubClient, putClubClient} from "@api/doinsport/services/client/client.api";
import {isNotUndefinedAndNotNull} from "@/utils/classes";

export default {
  data: () => ({
    client: new Client(),
    addressesIri: null,
    identityPhotoIri: null,
    validation: require('@validation/entities/doinsport/Client.json')
  }),
  props: {
    mode: {
      type: String,
      default: 'create'
    }
  },
  components: {
    ProfileInformations: () => import('./ProfileInformation'),
    PersonalInformations: () => import('./PersonalInformation'),
    Groups: () => import('./Groups'),
    Family: () => import('./Family'),
    CustomerDetails: () => import('./Details'),
  },
  computed: {
    innerWidth() {
      return this.$store.getters['layout/getInnerWidth'] > 700;
    }
  },
  methods: {
    getCols() {
      const width = this.$store.getters["layout/getInnerWidth"];

      if (width < 1368) {
        return '12';
      }
      return '6';
    },
    createOrUpdateCustomer() {
      let blobPhoto = null;
      try {
        this.$refs.customerObserver.validate().then((valid) => {
          if (valid) {
            this.client.club = '/clubs/' + this.$store.getters["auth/currentClub"].id;

            delete this.client.documents;
            delete this.client.familyGroup;
            blobPhoto = this.client.identityPhoto;
            delete this.client.identityPhoto;
            if (this.client.phoneNumber.trim().length === 0) {
              this.client.phoneNumber = null;
            }
            if (this.mode === 'create') {
              this.client.birthDate = this.getBirthdayFormat();
              postClubClient(this.client)
                .then((response) => {
                  if (isNotUndefinedAndNotNull(blobPhoto)) {
                    const payload = {entry: 'client', url: response.data['@id'], target: 'postClientIdentityPhoto'};
                    this.$uploadFile(blobPhoto, payload);
                    this.$router.push({name: 'customer_details', params: {id: response.data.id}});
                  } else {
                    this.$router.push({name: 'customer_details', params: {id: response.data.id}});
                  }
                })
              ;
            } else {
              const data = {
                id: this.client.id,
                firstName: this.client.firstName,
                lastName: this.client.lastName,
                phoneNumber: this.client.phoneNumber,
                email: this.client.email,
                affiliated: this.client.affiliated,
                addresses: this.client.addresses,
                birthDate: this.getBirthdayFormat(),
                accessCode: this.client.accessCode,
                licenceNumber: this.client.licenceNumber,
                company: this.client.company,
                gender: this.client.gender,
                description: this.client.description,
                medicalCertificate: this.client.medicalCertificate,
              }
              if (this.addressesIri === null) {
                putClubClient(data)
                  .then((response) => {
                    this.$emit('on:customer:update');
                  })
                ;
              } else {
                data.addresses[0].id = this.addressesIri;

                putClubClient(data)
                  .then((response) => {
                    this.$emit('on:customer:update');
                  })
                ;
              }
            }
          }
        })
      } catch (e) {
      }
    },
    getBirthdayFormat() {
      if (this.client.birthDate && this.client.birthDate !== '') {
        return this.$moment(this.client.birthDate).format('YYYY-MM-DDTHH:mm:ss');
      } else {
        return null;
      }
    }
  },
  beforeMount() {
    this.$store.dispatch('validator/set', this.validation);
  },
  created() {
    if (this.$route.name === 'customer_details') {
      getClubClient(this.$route.params.id)
        .then((response) => {
          this.client = new Client(response.data, {serialize: true});
          if (response.data.addresses.length) {
            this.addressesIri = response.data.addresses[0]['@id'];
            if (response.data.identityPhoto) {
              this.identityPhotoIri = response.data.identityPhoto['@id'];
            }
          }
        })
      ;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@lazy/_custom-buttom-mobile.scss";
@import "@lazy/_b-card.scss";
</style>
